import React, { Dispatch, useEffect } from 'react';
import { Form, Select, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { Action } from 'typesafe-actions';
import { pagArmazenagemRequest } from '../../store/ducks/pagadorArmazenagem/actions';
import { PagArmazenagemProps } from './props';
import mask from '../../utils/mask';
import TittleFilter from '../TextFilter';
const SelectPagadorArmazenagem: React.FC<PagArmazenagemProps> = ({
  setFiltro,
  setPagArmazenagem,
}) => {
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const pagArmazenagem = useSelector((state: ApplicationState) => state.PagadorArmazenagem.data);
  const loading = useSelector((state: ApplicationState) => state.PagadorArmazenagem.loading);
  // eslint-disable-next-line
  const dispatch = useDispatch<Dispatch<Action>>();
  const { Option } = Select;

  useEffect(() => {
    dispatch(pagArmazenagemRequest(inscricaoAtiva, cddAtivo?.codCdd));
  }, [dispatch, inscricaoAtiva, cddAtivo]);

  const onChange = (value: any) => {
    setPagArmazenagem(value);
    localStorage.setItem(`pagadorArmazenagem${window.location.pathname}`, value);
  };

  const children = [];
  children.push(
    pagArmazenagem?.map((inscData) => (
      <Option
        title={inscData.nome}
        className="optionselect"
        value={inscData.codParc}
        key={inscData.codParc}
      >
        CNPJ/CPF: {mask('cpfCnpj', inscData.cnpjCpf)} <br />
        Inscrição estadual: {inscData.inscricaoEstadual} <br />
        Nome: {inscData.nome} - Código: {inscData.codParc}
        <hr />
      </Option>
    ))
  );
  const localStorageItensPersist =
    localStorage.getItem(`pagadorArmazenagem${window.location.pathname}`) || '';
  return (
    <Form.Item
      label={<TittleFilter>Pagador da armazenagem</TittleFilter>}
      name="pagadorArmazenagem"
    >
      <Select data-cy="pagadorArmazenagem"
        style={{ width: '100%' }}
        onChange={onChange}
        showSearch
        filterOption={(inputValue, element) =>
          element?.props.children.toString().toLowerCase().includes(inputValue.toLowerCase())
        }
        defaultValue={localStorageItensPersist}
        loading={loading}
        notFoundContent={<Spin style={{textAlign:"center", width:"100%"}}/>}
      >
        {children}
      </Select>
    </Form.Item>
  );
};

export default SelectPagadorArmazenagem;
